import React from "react";
import LeadersQualificationList from "../../LeadersQualification/LeadersQualificationList";

const LeadersQualification = () => {
  return (
    <>
      <div className={"mb-2"}>
        <LeadersQualificationList />
      </div>
    </>
  );
};

export default LeadersQualification;
